import React from 'react';
import classNames from 'classnames';
import Truncate from 'react-truncate';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';

import {
  WysiwygField,
  CoreLink,
  AngledSquare,
} from '../../../../components';


import './style.scss';

const NodeBlogTeaser = ({ id, entity, className }) => {
  const classes = classNames(className, 'mb-6');

  return (
    <article typeof="schema:WebPage" className={classes}>
      <div className="NodeBlogTeaser Blog teaser moving-arrow--proxy">
        <CoreLink to={entity.getIn(['paths', DEFAULT_LANGUAGE])} className="overlapping-link">
          <div>
            <div className="NodeBlogTeaser__image">
              <Image
                alt={entity.getIn(['title', 0, 'value'])}
                src={{
                  0: entity.getIn(['field_image', 0, 'styles', 'teaser_image']),
                  768: entity.getIn(['field_image', 0, 'styles', 'large_teaser_image']),
                }}
                includeWebP
              />
              <AngledSquare size="40px">
                <CoreLink to={entity.getIn(['paths', DEFAULT_LANGUAGE])} className="icon-arrow-right icon-before icon-after moving-arrow icon-variant-4" />
              </AngledSquare>
            </div>

            <h3 className="NodeBlogTeaser__title">
              <div>
                <Truncate lines={2} ellipsis="..." trimWhitespace>
                  {entity.getIn(['title', 0, 'value'])}
                </Truncate>
              </div>
            </h3>
            <div className="NodeBlogTeaser__body">
              <Truncate lines={4} ellipsis="..." trimWhitespace>
                <WysiwygField
                  property="schema:text"
                  className="NodeBlogTeaser__body"
                  html={entity.getIn(['body', 0, 'processed'])}
                />
              </Truncate>
            </div>
          </div>
        </CoreLink>
      </div>
    </article>
  );
};

export default NodeBlogTeaser;
